module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/awesome-typescript-loader/dist/entry.js?silent=true!./costbook-cost-picker.ts"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./ClientApp/components/costbook-cost-picker/costbook-cost-picker.ts
// module id = 100
// module chunks = 53